import React from 'react'
import HomeComponent from '../Components/HomeComponent'
import Navbar from '../Components/Navbar'

const Home = () => {
  return (
    <div>
    <Navbar />
    <HomeComponent />
    </div>
  )
}

export default Home